import React from 'react';
import { getRelatedItemsPricing } from 'swag-common/business-logic';
import { Price } from 'swag-client-common/utils/price';
import ss from './regular-items-summary.scss';
const RegularItemsSummary = ({
  items
}) => {
  const {
    total
  } = getRelatedItemsPricing(items);
  return /*#__PURE__*/React.createElement("div", {
    className: ss.summaryContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: ss.summary
  }, /*#__PURE__*/React.createElement("div", {
    className: ss.item
  }, /*#__PURE__*/React.createElement("div", {
    className: ss.text
  }, "Total:"), /*#__PURE__*/React.createElement("div", {
    className: ss.pinkBold,
    "data-text": "RGroupItemsTotal"
  }, Price.formatPrice(total)))));
};
export default RegularItemsSummary;